import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// ui
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
// components
import DeleteModal from 'commons/components/DeleteModal';
import ItemList from 'screens/Employees/components/ItemList';
import Filters from './Filters';
import TableActionMenu from 'commons/components/TableActionMenu';
import ImportModal from 'commons/components/Modal';
import EmployeeForm from './EmployeeForm';
import { EMPLOYEES } from '../reducer';

function EmployeesComponent(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const importLoader = useSelector((state) => state?.employees.importing);
  const importLoaderSuccess = useSelector((state) => state?.employees.importSuccess);
  useEffect(() => {
    if (!importLoader) {
      setIsUploading(false);
    }
    if (importLoaderSuccess) {
      setImportModalOpen(false);
      setImportModalOpen(false);
      setSelectedFile(null);
    }
  }, [importLoader, importLoaderSuccess]);
  // Agregar estas funciones
  const handleImportModal = () => setImportModalOpen(true);
  const handleCloseImport = () => {
    setImportModalOpen(false);
    setSelectedFile(null);
  };

  const handleFileUpload = (file) => {
    setSelectedFile(file);
  };

  const handleImport = (type) => {
    if (selectedFile && !isUploading) {
      setIsUploading(true);
      setImportModalOpen(true);
      dispatch({
        type: EMPLOYEES.IMPORT_EMPLOYEES,
        payload: {
          file: selectedFile,
          type,
          socketId: props.socketId,
        },
      });
      setSelectedFile(null);
      setIsUploading(false);
    }
  };

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={props.classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={props.classes.marginTop}>
            {t('Employees')}
          </Typography>
        </Grid>
        <Filters
          classes={props.classes}
          filter={props.filter}
          onFilterChange={props.onFilterChange}
          objects={props.objects}
        />
        <Grid container item>
          <Grid item xs={12} sm={4} md={3}>
            <TableActionMenu
              menuItems={[
                {
                  label: t('Export'),
                  listItems: [
                    {
                      label: t('Excel file'),
                      onClick: props.actions.exportEmployees,
                      params: [props.employeeList],
                    },
                  ],
                },
                {
                  label: t('Import'),
                  listItems: [
                    {
                      label: t('Mass Upload'),
                      onClick: handleImportModal,
                      params: [],
                    },
                  ],
                },
              ]}
            />
          </Grid>
        </Grid>
        <ItemList
          classes={props.classes}
          objects={props.objects}
          toggleEdit={props.toggleEdit}
          toggleDelete={props.toggleDelete}
          employeeList={props.employeeList}
          anchorEl={props.anchorEl}
          handleClick={props.handleClick}
          handleClose={props.handleClose}
        />
      </Grid>
      <EmployeeForm
        isOpen={props.formIsOpen}
        toggleForm={props.toggleForm}
        changeControls={props.changeControls}
        onChange={props.actions.changeControls}
        controls={props.formControls}
        edit={props.edit}
        submit={props.submit}
        invalidControls={props.invalidControls}
        objects={props.objects}
        country={props.country}
      />
      <DeleteModal
        isOpen={props.deleteIsOpen}
        toggleForm={props.closeForm}
        submit={props.submitDelete}
        buttonId="delete-employee"
      />
      <Fab
        color="primary"
        aria-label="add"
        className={props.classes.fab}
        onClick={props.toggleForm}>
        <AddIcon />
      </Fab>
      <ImportModal
        isOpen={importModalOpen}
        onClose={handleCloseImport}
        onImport={handleImport}
        onUploadFile={handleFileUpload}
        type="employees"
        selectedFile={selectedFile}
        isUploading={isUploading}
      />
    </Container>
  );
}

export default EmployeesComponent;
